/* Gutful PDP theme interactions.
   Loaded (deferred) by every gutful-* section that needs JS; the init
   guard makes duplicate <script> tags harmless. Re-runs on
   shopify:section:load so the theme editor stays live. */
(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('[data-gf-gallery-main]');
    var thumbs = root.querySelectorAll('.gf-hero__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        main.src = thumb.dataset.image;
        main.style.objectFit = thumb.dataset.fit || 'cover';
      });
    });
  }

  function initBuyBox(root) {
    var options = root.querySelectorAll('.gf-supply-option');
    var cta = root.querySelector('[data-gf-atc]');
    var ctaPrice = root.querySelector('[data-gf-cta-price]');
    var onetimePrice = root.querySelector('[data-gf-onetime-price]');
    var subPrice = root.querySelector('[data-gf-sub-price]');
    if (!options.length || !cta) return;

    var mode = 'subscription'; // matches the design default

    function selected() {
      return root.querySelector('.gf-supply-option.is-selected') || options[0];
    }

    function render() {
      var opt = selected();
      var price = mode === 'subscription' ? opt.dataset.priceSub : opt.dataset.priceOnetime;
      if (ctaPrice) ctaPrice.textContent = price;
      if (onetimePrice) onetimePrice.textContent = opt.dataset.priceOnetime;
      if (subPrice) subPrice.textContent = opt.dataset.priceSub;
      root.querySelectorAll('[data-gf-mode-line]').forEach(function (line) {
        // the "onetime" line offers switching TO one-time, so it shows in subscription mode
        var showIn = line.dataset.gfModeLine === 'onetime' ? 'subscription' : 'onetime';
        line.hidden = mode !== showIn;
      });
    }

    var mainImage = root.querySelector('[data-gf-gallery-main]');
    var thumbs = root.querySelectorAll('.gf-hero__thumb');

    function showVariantImage(option) {
      var src = option.dataset.variantImage;
      if (!src || !mainImage) return;
      mainImage.src = src;
      mainImage.style.objectFit = 'cover';
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.image === src);
      });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-checked', 'false');
        });
        option.classList.add('is-selected');
        option.setAttribute('aria-checked', 'true');
        showVariantImage(option);
        render();
      });
    });

    root.querySelectorAll('[data-gf-mode-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        mode = link.dataset.gfModeToggle === 'onetime' ? 'onetime' : 'subscription';
        render();
      });
    });

    cta.addEventListener('click', function () {
      var opt = selected();
      var variantId = opt.dataset.variantId;

      // Placeholder mode (no product variant wired): stub feedback only.
      if (!variantId) {
        flash(cta, 'ADDED TO CART ✓');
        return;
      }

      var item = { id: Number(variantId), quantity: 1 };
      if (mode === 'subscription' && opt.dataset.sellingPlan) {
        item.selling_plan = Number(opt.dataset.sellingPlan);
      }

      cta.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // Section Rendering API: the response bundles fresh drawer HTML so
        // no second round-trip is needed to update the slide-out cart.
        body: JSON.stringify({ items: [item], sections: 'cart-drawer-section' })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function (json) {
          if (root.dataset.afterAtc === 'cart') {
            window.location.href = '/cart';
            return;
          }
          cta.disabled = false;
          flyToCart(opt.dataset.variantImage || (mainImage && mainImage.src), cta);
          refreshCartCount();
          // Morph the drawer contents from the add-response (instant, in place),
          // then open it as the fly-to-cart arc lands.
          notifyCartComponents(cta, json.sections);
          setTimeout(openCartDrawer, 420);
          flash(cta, 'ADDED TO CART ✓');
          document.dispatchEvent(new CustomEvent('gutful:cart:added', { detail: item }));
        })
        .catch(function () {
          cta.disabled = false;
          flash(cta, 'COULD NOT ADD — TRY AGAIN');
        });
    });

    function flash(button, text) {
      var original = button.innerHTML;
      button.textContent = text;
      button.disabled = true;
      setTimeout(function () {
        button.innerHTML = original;
        button.disabled = false;
        render(); // restore live price span
      }, 1600);
    }

    render();
  }

  /* "Throw it in the cart" — reuses Horizon's <fly-to-cart> element (its
     styles/keyframes live in the theme's base.css) when available, with a
     minimal WAAPI arc as the fallback on other themes. */
  function flyToCart(image, sourceEl) {
    var dest = document.querySelector('[data-gf-cart-icon]') || document.querySelector('.header-actions__cart-icon');
    if (!dest || !image || !sourceEl) return;

    if (window.customElements && customElements.get('fly-to-cart')) {
      var el = document.createElement('fly-to-cart');
      el.classList.add('fly-to-cart--main');
      el.style.setProperty('background-image', 'url(' + image + ')');
      el.style.setProperty('--start-opacity', '0');
      el.source = sourceEl;
      el.destination = dest;
      document.body.appendChild(el);
      return;
    }

    var s = sourceEl.getBoundingClientRect();
    var d = dest.getBoundingClientRect();
    var ghost = document.createElement('img');
    ghost.src = image;
    ghost.style.cssText = 'position:fixed;z-index:2147483647;pointer-events:none;width:56px;height:56px;object-fit:cover;border-radius:12px;' +
      'left:' + (s.left + s.width / 2 - 28) + 'px;top:' + (s.top + s.height / 2 - 28) + 'px;';
    document.body.appendChild(ghost);
    ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (d.left + d.width / 2 - (s.left + s.width / 2)) + 'px,' + (d.top + d.height / 2 - (s.top + s.height / 2)) + 'px) scale(0.2)', opacity: 0.3 }
      ],
      { duration: 650, easing: 'cubic-bezier(0.5, -0.3, 0.8, 0.6)' }
    ).finished.then(function () { ghost.remove(); }).catch(function () { ghost.remove(); });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-gf-cart-count]').forEach(function (b) {
          b.textContent = cart.item_count;
          b.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* Horizon's slide-out cart. The theme's own header (which triggered it)
     is replaced by the Gutful header, so we drive the <theme-drawer>
     directly: re-render its section for fresh line items, then open(). */
  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var dialog = drawer && drawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      return true;
    }
    return false;
  }

  /* Hand the add-response's section HTML to Horizon's own cart components
     via their standard event: cart-items-component morphs the drawer in
     place (no innerHTML rebuild, no extra fetch) and the drawer auto-opens
     only if the merchant enabled that theme setting — identical feel to a
     stock product page. No-op on themes without these components. */
  function notifyCartComponents(sourceEl, sections) {
    if (!sections) return;
    try {
      var ev = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
      ev.action = 'add';
      ev.promise = Promise.resolve({ detail: { sections: sections } });
      (sourceEl || document).dispatchEvent(ev);
    } catch (e) { /* non-critical enhancement */ }
  }

  function initCartIcons(scope) {
    scope.querySelectorAll('[data-gf-cart-icon]').forEach(function (icon) {
      if (icon.dataset.gfDrawerInit) return;
      icon.dataset.gfDrawerInit = '1';
      icon.addEventListener('click', function (e) {
        // Toggle: a second click on the icon closes an already-open drawer.
        var drawer = document.getElementById('cart-drawer');
        var dialog = drawer && drawer.querySelector('dialog');
        if (dialog && dialog.open) {
          e.preventDefault();
          if (typeof drawer.close === 'function') drawer.close();
          else dialog.close();
          return;
        }
        if (openCartDrawer()) e.preventDefault();
      });
    });
  }

  function initBaSlider(root) {
    var slider = root.querySelector('[data-gf-ba]') || (root.matches && root.matches('[data-gf-ba]') ? root : null);
    if (!slider || slider.dataset.gfBaInit) return;
    slider.dataset.gfBaInit = '1';
    var handle = slider.querySelector('.gf-ba__handle');

    function setReveal(pct) {
      var clamped = Math.max(2, Math.min(98, pct));
      slider.style.setProperty('--gf-ba-reveal', clamped + '%');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(clamped));
    }

    function pctFromEvent(e) {
      var rect = slider.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    var dragging = false;
    slider.addEventListener('pointerdown', function (e) {
      dragging = true;
      slider.setPointerCapture(e.pointerId);
      setReveal(pctFromEvent(e));
    });
    slider.addEventListener('pointermove', function (e) {
      if (dragging) setReveal(pctFromEvent(e));
    });
    slider.addEventListener('pointerup', function () { dragging = false; });
    slider.addEventListener('pointercancel', function () { dragging = false; });

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(getComputedStyle(slider).getPropertyValue('--gf-ba-reveal')) || 30;
        if (e.key === 'ArrowLeft') setReveal(current - 4);
        if (e.key === 'ArrowRight') setReveal(current + 4);
      });
    }
  }

  function initScope(scope) {
    scope.querySelectorAll('[data-gf-hero]').forEach(function (hero) {
      if (hero.dataset.gfInit) return;
      hero.dataset.gfInit = '1';
      initGallery(hero);
      initBuyBox(hero);
    });
    scope.querySelectorAll('[data-gf-ba]').forEach(initBaSlider);
    initCartIcons(scope.querySelectorAll ? scope : document);
  }

  function boot() { initScope(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else if (!window.__gutfulBooted) {
    boot();
  }
  window.__gutfulBooted = true;

  // Theme editor: re-init sections as they are re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initScope(e.target);
  });
})();
